/* === Scroll vers nouveaux produits après « Voir plus » — Numerigram ===
   v2 — 03/10/2026
   Le défilement ne part QUE après un clic réel du visiteur sur « Voir plus ».
   Avant, il réagissait à tout ajout dans la grille, y compris les pages chargées
   en silence par sdo-ruptures-en-dernier.js à l'arrivée : le visiteur venu d'un
   lien (une saison, une famille…) atterrissait en bas de la collection.
   Cible : la première carte devenue visible qui ne l'était pas avant le clic. */
(function () {
  var grid = document.querySelector('[data-product-grid]');
  if (!grid) return;

  var DELAI_MAX = 12000;
  var attente = null;
  var minuteur = null;

  function visibles() {
    var cartes = grid.querySelectorAll('[data-available]');
    var liste = [];
    for (var i = 0; i < cartes.length; i++) {
      if (cartes[i].offsetParent !== null) liste.push(cartes[i]);
    }
    return liste;
  }

  function estVoirPlus(noeud) {
    while (noeud && noeud !== document) {
      if (noeud.classList && noeud.classList.contains('js-load-more')) return true;
      noeud = noeud.parentNode;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !estVoirPlus(e.target)) return;
    attente = { depuis: Date.now(), avant: visibles() };
    clearTimeout(minuteur);
    minuteur = setTimeout(verifier, 300);
  }, true);

  function verifier() {
    if (!attente) return;
    if (Date.now() - attente.depuis > DELAI_MAX) { attente = null; return; }
    var maintenant = visibles();
    for (var i = 0; i < maintenant.length; i++) {
      if (attente.avant.indexOf(maintenant[i]) === -1) {
        var cible = maintenant[i];
        attente = null;
        cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
  }

  var observer = new MutationObserver(function () {
    if (!attente) return;
    clearTimeout(minuteur);
    minuteur = setTimeout(verifier, 150);
  });
  observer.observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
